import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../utils';
import {
  getLastUsedBankOrCashAccount,
  GetLastUsedBankOrCashAccountQueryVariables,
  GetLastUsedBankOrCashAccountQuery,
  GetMinMaxInvoiceDateQuery,
  getMinMaxInvoiceDate,
  GetMinMaxInvoiceDateQueryVariables,
} from '../../../graphql';
import { RTK_CACHE_LIFETIME } from '../../../config';

type GetLastUsedBankOrCashAccountQueryResponse = {
  LastBankAccount: string | null | undefined;
  lastCashAccount: string | null | undefined;
  LastBankAccountName: string | null | undefined;
  lastCashAccountName: string | null | undefined;
};

type GetMinMaxInvoiceDateResponse = {
  prevInvoiceDate: string | null | undefined;
  nextInvoiceDate: string | null | undefined;
  latestInvoiceDate: string | null | undefined;
  openingBalanceDate: string | null | undefined;
};

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: baseQuery,
  tagTypes: ['lastUsedAccount'],
  endpoints: (builder) => ({
    getLastUsedBankOrCashAccount: builder.query<GetLastUsedBankOrCashAccountQueryResponse, GetLastUsedBankOrCashAccountQueryVariables>({
      query: (variables) => ({ body: getLastUsedBankOrCashAccount, variables }),
      keepUnusedDataFor: RTK_CACHE_LIFETIME,
      transformResponse: (response: GetLastUsedBankOrCashAccountQuery) => {
        return {
          LastBankAccount: response.getLastUsedBankOrCashAccount?.bankpaidtoaccountid,
          lastCashAccount: response.getLastUsedBankOrCashAccount?.cashpaidtoaccountid,
          LastBankAccountName: response.getLastUsedBankOrCashAccount?.bankpaidtoaccountname,
          lastCashAccountName: response.getLastUsedBankOrCashAccount?.cashpaidtoaccountname,
        };
      },
      providesTags: (result, error, arg) => [{ type: 'lastUsedAccount', id: arg.transactiontypecd }],
    }),

    getMinMaxInvoiceDate: builder.query<GetMinMaxInvoiceDateResponse, GetMinMaxInvoiceDateQueryVariables>({
      query: (variables) => ({
        body: getMinMaxInvoiceDate,
        variables,
      }),
      transformResponse: (response: GetMinMaxInvoiceDateQuery) => {
        const data = response?.getMinMaxInvoiceDate;
        return {
          prevInvoiceDate: data?.previnvoicedate,
          nextInvoiceDate: data?.nextinvoicedate,
          latestInvoiceDate: data?.latestinvoicedate,
          openingBalanceDate: data?.openingbalancedate,
        };
      },
    }),
  }),
});

export const {
  useLazyGetLastUsedBankOrCashAccountQuery,
  useGetLastUsedBankOrCashAccountQuery,
  usePrefetch,
  useLazyGetMinMaxInvoiceDateQuery,
  useGetMinMaxInvoiceDateQuery,
} = paymentApi;
